/**
 * @generated SignedSource<<38a45eea482f34108d4b3c83f1e628a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleShiftsEmployee_employee$data = {
  readonly id: string;
  readonly shifts: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleShiftBar">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleNameEmployeeNamePanel_employee">;
  readonly " $fragmentType": "EmployeeScheduleShiftsEmployee_employee";
};
export type EmployeeScheduleShiftsEmployee_employee$key = {
  readonly " $data"?: EmployeeScheduleShiftsEmployee_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleShiftsEmployee_employee">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeScheduleShiftsEmployee_employee",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EmployeeScheduleNameEmployeeNamePanel_employee"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeShift",
      "kind": "LinkedField",
      "name": "shifts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployeeScheduleShiftBar"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};
})();

(node as any).hash = "8ed4ff78ac8168ce9dc2a03fc347f793";

export default node;
